import titleLink from '@components/ui-components/title-link/component.js'
import caseService from '@components/ui-components/case-service/component.js'

export default {
  components: {
    'title-link-cmp': titleLink,
    'case-service-cmp': caseService,
  },
  data() {
    return {}
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/widget/cases/component.js